





























































































































































import { Component, Vue, Prop, Watch, Provide } from "vue-property-decorator";
import router from "@/router";
import axios from "axios";
import _ from "lodash";
import CustomSelectBox from "@/components/CustomSelectBox.vue";
import TaxabilityTable from "@/components/TaxabilityTable.vue";
import analyticsLayerUtil from "./../utils/index";
/* eslint-disable @typescript-eslint/camelcase */
interface TaxCode {
  code: string;
  description: string;
  additionalDescription: string;
  categories: string[];
}
interface TaxCodeSearchResponse {
  code: string;
  short_desc: string;
}
interface TaxabilityRule {
  taxability: string;
  jurisdiction_name: string;
  jurisdiction_code: string;
  country_code: string;
  jurisdiction_type: string;
  additional_info: string;
}
interface TaxabilityRules {
  taxcode: string;
  rules: TaxabilityRule[];
}
interface SelectOption {
  label: string;
  value: string;
  selected?: boolean;
}

interface Jurisdiction {
  name: string;
  code: string;
  type: string;
}

interface JurisdictionResponse {
  country_code: string;
  country_name: string;
  jurisdictions: Jurisdiction[];
}

enum Region {
  US = "US",
  CA = "CA",
}
@Component({
  components: {
    CustomSelectBox,
    TaxabilityTable,
  },
})
export default class TaxabilitySearch extends Vue {
  @Provide("$api") $api: any;
  @Prop({ default: "" }) private selectedTaxCodes!: string;
  @Prop({ default: "" }) private selectedJurisdictions!: string;
  @Prop({ default: Region.US }) private selectedRegion!: string;
  Region = Region;
  taxcodeLimit = 20;
  selectBoxKey = "0";
  selectedTaxCodesParsed: string[] =
    this.selectedTaxCodes.length > 0 ? this.selectedTaxCodes.split(",") : [];
  selectedJurisdictionsParsed: string[] =
    this.selectedJurisdictions.length > 0
      ? this.selectedJurisdictions.split(",")
      : [];
  selectedRegionOption: string = this.selectedRegion;
  allRegionsData: SelectOption[] = [
    {
      label: "United States of America (USA)",
      value: Region.US,
    },
    { label: "Canada", value: Region.CA },
  ];
  allTaxCodesData: SelectOption[] = [];
  allJurisdictionsData: SelectOption[] = [];
  taxabilities: TaxabilityRules[] = [];
  codeToJurisdictionTaxability: {
    [taxCode: string]: { [jurisdiction: string]: TaxabilityRule };
  } = {};
  isSearchInputError = false;

  mounted() {
    this.allRegionsData = this.allRegionsData.map((regionData) =>
      regionData.value === this.selectedRegionOption
        ? { ...regionData, selected: true }
        : regionData
    );
    this.populateJurisdictions();
    this.loadTaxabilityUsingRoute();
  }

  public populateJurisdictions() {
    this.$api
      .get(`/api/jurisdictions/`)
      .then((response) => {
        const allJurisdictionsForCountries: JurisdictionResponse[] =
          response.data;
        allJurisdictionsForCountries.forEach((countryJurisdictions) => {
          this.$store.commit("setCountryJurisdictions", {
            countryCode: countryJurisdictions.country_code,
            jurisdictionNames: countryJurisdictions.jurisdictions.map(
              (j) => j.name
            ),
          });
        });
        const jurisdictionsToPopulate: string[] = this.$store.getters.countryJurisdictions(
          this.getSelectedRegion()
        );
        this.allJurisdictionsData = jurisdictionsToPopulate.map(
          (jurisdiction: string) => {
            const jurisdictionData: SelectOption = {
              label: jurisdiction,
              value: jurisdiction,
              selected:
                this.selectedJurisdictionsParsed.length > 0 &&
                this.selectedJurisdictionsParsed.indexOf(jurisdiction) > -1,
            };
            return jurisdictionData;
          }
        );
      })
      .catch((error) => this.$store.commit("stopLoading"));
  }

  public loadTaxabilityUsingRoute() {
    this.$api
      .post("/api/taxcodes/", this.selectedTaxCodesParsed)
      .then((response) => {
        const allTaxCodes: TaxCode[] = response.data;
        this.allTaxCodesData = allTaxCodes.map((value: TaxCode) => ({
          label: `${value.code} - ${value.description.replace(/\s{2,}/g, " ")}`,
          value: value.code,
          selected: true,
        }));
        if (
          this.selectedTaxCodesParsed.length > 0 &&
          this.selectedJurisdictionsParsed.length > 0
        )
          this.loadTaxability();
      })
      .catch((error) => this.$store.commit("stopLoading"));
  }

  public loadTaxability(): void {
    if (this.getSelectedTaxCodesOptions().length > this.taxcodeLimit) {
      return;
    }
    this.$store.commit("startLoading");
    this.$api
      .post("/api/taxability/", {
        taxcodes: this.selectedTaxCodesParsed,
        state_codes: [],
        country_codes: [this.getSelectedRegion()],
      })
      .then((response) => {
        this.taxabilities = response.data;
        this.taxabilities.length === 0
          ? this.$store.commit("stopLoading")
          : this.updateCodeToJurisdictionTaxabilityMap();
        this.captureTaxabilitySearch(
          this.selectedTaxCodesParsed,
          this.getSelectedRegion(),
          this.selectedJurisdictionsParsed
        );
      })
      .catch((error) => this.$store.commit("stopLoading"));
  }

  public captureTaxabilitySearch(
    taxcodes: string[],
    country: string,
    states: string[]
  ) {
    const allJurisSelected = this.allJurisdictionsData.every(
      (jurisdiction) => jurisdiction.selected
    );
    const analyticsJurisData = [
      ...(allJurisSelected ? ["all-jurisdictions"] : []),
      ...states,
    ];
    const props = {
      taxibilityMatrix: {
        taxibilityMatrixInfo: {
          taxCodes: taxcodes.join(","),
          selectedCountry: country,
          selectedStates: analyticsJurisData.join("|"),
        },
      },
    };
    analyticsLayerUtil.addToDataLayer(props);
    if (this.$store.getters.analyticsEnabled) {
      window._satellite.track("taxability_build");
    }
  }

  public updateCodeToJurisdictionTaxabilityMap(): void {
    this.taxabilities.forEach((taxability: TaxabilityRules) => {
      const taxCode: string = taxability.taxcode;
      const jurisdictionsToTaxability: { [key: string]: TaxabilityRule } = {};
      taxability.rules.forEach((rule: TaxabilityRule) => {
        const jurisdiction: string = rule.jurisdiction_name;
        jurisdictionsToTaxability[jurisdiction] = rule;
      });
      Vue.set(
        this.codeToJurisdictionTaxability,
        taxCode,
        jurisdictionsToTaxability
      );
    });
  }
  public searchJurisdictions(e: any): void {
    return e.detail.inputValue;
  }

  public bulkSelectTaxcodes(searchQuery: string) {
    const taxcodes =
      searchQuery.indexOf(" ") > 0
        ? searchQuery.trim().split(/\s+/)
        : searchQuery.trim().split(",");

    const uniqTaxcodes = _.uniq(taxcodes);
    this.$store.commit("startLoading");
    this.$api
      .post("/api/taxcodes/", uniqTaxcodes)
      .then((response) => {
        const bulkTaxCodes: TaxCode[] = _.uniqBy(
          response.data,
          (taxcode) => taxcode.code
        );
        const isInputValid = uniqTaxcodes.length === bulkTaxCodes.length;
        if (!isInputValid) {
          this.isSearchInputError = true;
          this.$store.commit("stopLoading");
          return;
        }
        this.isSearchInputError = false;
        const bulkTaxCodesData: SelectOption[] = bulkTaxCodes.map(
          (value: TaxCode) => ({
            label: `${value.code} - ${value.description.replace(
              /\s{2,}/g,
              " "
            )}`,
            value: value.code,
            selected: true,
          })
        );
        const allTaxCodesDataDeduped = this.allTaxCodesData.filter(
          (data) =>
            bulkTaxCodes
              .map((bulkTaxCode) => bulkTaxCode.code)
              .indexOf(data.value) < 0
        );
        this.allTaxCodesData = [...allTaxCodesDataDeduped, ...bulkTaxCodesData];
        this.selectBoxKey = this.selectBoxKey + 1;
        this.$store.commit("stopLoading");
      })
      .catch((error) => this.$store.commit("stopLoading"));
  }

  public searchTaxCodes(e: any): void {
    this.isSearchInputError = false;
    const searchQuery: string = e.detail.inputValue.trim();
    const pattern = /^([a-zA-Z0-9 ,]*)$/;
    if (searchQuery === "" || !pattern.test(searchQuery)) return;
    if (searchQuery.indexOf(",") >= 0 || searchQuery.indexOf(" ") >= 0) {
      this.bulkSelectTaxcodes(searchQuery);
    } else {
      this.$api
        .get(`/api/taxcode_autosuggest/?searchterm=${searchQuery}`)
        .then((response) => {
          const selectedTaxCodesData: SelectOption[] = this.allTaxCodesData.filter(
            (taxCodeData) => {
              return taxCodeData.selected;
            }
          );
          const searchedTaxCodes: TaxCodeSearchResponse[] = response.data
            .results
            ? response.data.results
            : [];

          const searchedTaxCodesFiltered: TaxCodeSearchResponse[] = searchedTaxCodes.filter(
            (taxCode) =>
              selectedTaxCodesData
                .map((taxCodeData) => taxCodeData.value)
                .indexOf(taxCode.code) < 0
          );
          const searchedTaxCodesData: SelectOption[] = searchedTaxCodesFiltered.map(
            (searchResponse) => ({
              label: `${
                searchResponse.code
              } - ${searchResponse.short_desc.replace(/\s{2,}/g, " ")}`,
              value: searchResponse.code,
              selected: undefined,
            })
          );
          this.allTaxCodesData = [
            ...selectedTaxCodesData,
            ...searchedTaxCodesData,
          ];
        })
        .catch((error) => this.$store.commit("stopLoading"));
    }
  }
  public onRegionSelected(e: any) {
    const region = e.detail.item.value;
    if (this.getSelectedRegion() == region) return;
    else {
      this.selectedRegionOption = region;
      this.selectedJurisdictionsParsed = [];
      this.allJurisdictionsData = [];
      this.taxabilities = [];
      //a hack to re-render and clear the selectbox component to handle a bug in selectbox
      this.selectBoxKey = this.selectBoxKey + 1;
      const jurisdictionsToPopulate: string[] = this.$store.getters.countryJurisdictions(
        this.getSelectedRegion()
      );
      this.allJurisdictionsData = jurisdictionsToPopulate.map(
        (jurisdiction: string) => {
          const jurisdictionData: SelectOption = {
            label: jurisdiction,
            value: jurisdiction,
            selected:
              this.selectedJurisdictionsParsed.length > 0 &&
              this.selectedJurisdictionsParsed.indexOf(jurisdiction) > -1,
          };
          return jurisdictionData;
        }
      );
    }
  }
  public onTaxCodeSelected(e: any): void {
    const selectedOption = e.detail.item.value;
    this.allTaxCodesData = this.allTaxCodesData.map((taxCodeData) =>
      taxCodeData.value === selectedOption
        ? { ...taxCodeData, selected: true }
        : taxCodeData
    );
  }
  public onTaxCodeDeselected(e: any): void {
    this.allTaxCodesData = this.allTaxCodesData.map((taxCodeData) => {
      return taxCodeData.value === e.detail.item.value
        ? { ...taxCodeData, selected: undefined }
        : taxCodeData;
    });
    this.selectBoxKey = this.selectBoxKey + 1;
  }
  public onJurisdictionSelected(e: any): void {
    this.allJurisdictionsData = this.allJurisdictionsData.map(
      (jurisdictionData) => {
        return jurisdictionData.value == e.detail.item.value
          ? { ...jurisdictionData, selected: true }
          : jurisdictionData;
      }
    );
  }
  public onJurisdictionDeselected(e: any): void {
    this.allJurisdictionsData = this.allJurisdictionsData.map(
      (jurisdictionData) => {
        return jurisdictionData.value == e.detail.item.value
          ? { ...jurisdictionData, selected: undefined }
          : jurisdictionData;
      }
    );
    this.selectBoxKey = this.selectBoxKey + 1;
  }
  public onSelectAllJurisdictions() {
    const allJurisdictions = this.allJurisdictionsData.map(
      (jurisdictionData) => jurisdictionData.value
    );
    this.allJurisdictionsData = this.allJurisdictionsData.map(
      (jurisdictionData) => {
        return { ...jurisdictionData, selected: true };
      }
    );
    this.selectBoxKey = this.selectBoxKey + 1;
  }
  public onUnselectAllJurisdictions() {
    this.allJurisdictionsData = this.allJurisdictionsData.map(
      (jurisdictionData) => {
        return { ...jurisdictionData, selected: undefined };
      }
    );
    //a hack to re-render and clear the selectbox component to handle a bug in selectbox
    this.selectBoxKey = this.selectBoxKey + 1;
  }
  public onTaxabilitySearch() {
    this.selectedTaxCodesParsed = this.getSelectedTaxCodesOptions();
    this.selectedJurisdictionsParsed = this.getSelectedJurisdictionsOptions();
    this.updateRoute();
    this.loadTaxability();
  }

  public updateRoute(): void {
    const taxcodes: string = this.selectedTaxCodesParsed.sort().join(",");
    const jurisdictions: string = this.selectedJurisdictionsParsed.join(",");
    const region = this.getSelectedRegion();
    router.push({
      name: "taxability_search",
      query: {
        taxcodes,
        jurisdictions,
        region,
      },
    });
  }
  public getSelectedRegion(): string {
    return this.selectedRegionOption;
  }
  public getSelectedTaxCodesOptions() {
    const filteredTaxCodes = this.allTaxCodesData
      .filter((taxCodesData) => taxCodesData.selected)
      .map((taxCodesData) => taxCodesData.value);
    return filteredTaxCodes;
  }
  public getSelectedJurisdictionsOptions() {
    const filteredJurisdictions = this.allJurisdictionsData
      .filter((jurisdictionData) => jurisdictionData.selected)
      .map((jurisdictionData) => jurisdictionData.value);
    return filteredJurisdictions;
  }
  public getStatesSelectBoxLabel() {
    if (this.getSelectedRegion() === "CA") return "Select provinces";
    else return "Select states";
  }
  /* eslint-enable @typescript-eslint/camelcase */
}
